import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, ControlLabel, Form, FormControl, FormGroup } from 'react-bootstrap';

import { auth } from '../firebase';

const SignInPage = ({ history }) =>
  <div>
    <SignInNav />
    <SignInForm history={history} />
  </div>

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

class SignInForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      error: null,
    };
  }

  onSubmit = (event) => {
    const {
      email,
      password,
    } = this.state;

    const {
      history,
    } = this.props;

    auth.doSignInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState(() => ({
          email: '',
          password: '',
          error: null,
        }));
        history.push('/view');
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });

    event.preventDefault();
  }

  render() {
    const {
      email,
      password,
      error,
    } = this.state;

    return (
      <Form horizontal onSubmit={this.onSubmit} style={{ marginLeft: '10px', marginRight: '10px', marginTop: "20px" }}>
        <FormGroup>
          <ControlLabel>Epost</ControlLabel>
          <FormControl
            value={email}
            onChange={event => this.setState(byPropKey('email', event.target.value))}
            type="text"
            placeholder="Email Address"
          />
        </FormGroup>
        <FormGroup>
          <ControlLabel>Passord</ControlLabel>
          <FormControl
            value={password}
            onChange={event => this.setState(byPropKey('password', event.target.value))}
            type="password"
            placeholder="Password"
          />
        </FormGroup>
        <FormGroup>
        <Button bsStyle="success" type="submit">
          Logg inn
        </Button>
        </FormGroup>

        { error && <p>{error.message}</p> }
      </Form>
    );
  }
}

const SignInNav = () =>
  <nav class="navbar navbar-expand-lg navbar-light bg-light navbar-collapse">
    <a class="navbar-brand" href="#">NHO Transport</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNavDropdown">
      <ul class="navbar-nav">
        <li class="nav-item active">
          <a class="nav-link" href="/register">Registrer ny observasjon<span class="sr-only">(current)</span></a>
        </li>
      </ul>
    </div>
  </nav>

export default withRouter(SignInPage);

export {
  SignInForm,
};


// WEBPACK FOOTER //
// ./src/components/SignIn.js